<template>
  <div>
    <notifications
      position="top right"
      class="base-snackbar"
      reverse
      :type="data.type"
      :speed="400"
      :max="30"
      :width="450"
      :duration="data.duration || 6000"
    >
      <template slot="body" slot-scope="props">
        <v-layout align-center :class="{'pa-2': props.item.text.length > 80}">
          <v-flex xs1>
            <span class="dot" :class="[`base-snackbar--${props.item.type}`]"></span>
          </v-flex>
          <v-flex xs10>
            <span class="title" v-html="props.item.text"></span>
          </v-flex>
          <v-flex xs1 align-self-end>
            <v-btn flat icon color="white close-icon">
              <v-icon v-if="data.buttonRefresh" @click="onRefresh">refresh</v-icon>
              <v-icon @click="props.close">close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
    </notifications>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    data: {
      type: Object
    }
  },
  watch: {
    data: {
      deep: true,
      handler(data) {
        if (data.show) {
          this.$notify({ text: data.text, type: data.type });
        }
      }
    }
  },
  methods: {
    onRefresh() {
      window.location.reload();
    }
  }
};
</script>

<style lang="scss" scoped>
.base-snackbar {
  right: 15px !important;

  /deep/ .notification-wrapper {
    background-color: $sidebarColor;
    padding: 0 18px;
    margin: 10px 0;
    border-radius: 4px;
    line-height: 0;
  }
  /deep/ .vue-notification-wrapper {
    background-color: $sidebarColor;
    padding: 0 18px;
    margin: 10px 0;
    border-radius: 4px;
    line-height: 0;
  }

  .title {
    font-family: "TT Norms Regular" !important;
    font-size: 16px !important;
    color: #fff;
  }

  .close-icon {
    text-align: right;
  }

  .dot {
    height: 8px;
    width: 8px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 10px;
  }

  &--success {
    background-color: $btnSuccessColor !important;
  }

  &--info {
    background-color: #bbb !important;
  }

  &--error {
    background-color: #fe0101 !important;
  }
}
</style>